/**
 * Replaces a target element with HTML content from a string
 * @param htmlString - The HTML string to parse and insert
 * @param targetElement - The element to be replaced or updated
 * @param replace - If true, replaces the element itself; otherwise, replaces innerHTML
 * @returns The newly inserted element or null if replacement failed
 */
export function replaceElementWithHtml(
  htmlString: string,
  targetElement: Element,
  replace = false
): Element | null {
  if (!htmlString || !targetElement) {
    return null;
  }

  // Track focused element by ID or name
  const activeElement = document.activeElement as any;

  let focusSelector: string | null = null;

  if (activeElement && targetElement.contains(activeElement)) {
    if (activeElement.id) {
      focusSelector = `#${activeElement.id}`;
    } else if (activeElement.name) {
      focusSelector = `[name="${activeElement.name}"]`;
    }
  }

  const temp = document.createElement("div");
  temp.innerHTML = htmlString.trim();

  const newElement = temp.firstElementChild;

  if (newElement) {
    if (replace) {
      targetElement.replaceWith(newElement);

      // Restore focus
      if (focusSelector) {
        const elementToFocus = newElement.querySelector(focusSelector) as HTMLElement;
        elementToFocus?.focus();
      }

      return newElement;
    } else {

      targetElement.innerHTML = newElement.outerHTML;

      // Restore focus
      if (focusSelector) {
        const elementToFocus = targetElement.querySelector(focusSelector) as HTMLElement;
        setTimeout(() => {
          elementToFocus?.focus();
        });
      }

      return targetElement;

    }
  }

  return null;
}
